import { render } from "./createOrder.vue?vue&type=template&id=63cdbe70&scoped=true"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"

import "./createOrder.vue?vue&type=style&index=0&id=63cdbe70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cdbe70"]])

export default __exports__